import { useEffect, useState } from "react";
import { fetchTrips } from "../Api/ViewTrip";
import { Container, Table } from "react-bootstrap";
//import "../Styling/ViewTrip.css";
import { toast } from "react-toastify";
import moment from "moment";
import { getProjectById } from "../Api/ProjectMaster";

const ViewTrip = () => {
  const [trips, setTrips] = useState([]);
  const [projects, setProjects] = useState([]); // store all projects

  useEffect(() => {
    const loadTrips = async () => {
      try {
        const data = await fetchTrips();
        setTrips(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Trips`);
      }
    };

    const loadProjects = async () => {
      try {
        const projectData = await getProjectById();
        setProjects(projectData || []);
        console.log(projectData);
      } catch (error) {
        toast.error(`🦄 Error Fetching Projects`);
      }
    };

    loadTrips();
    loadProjects();
  }, []);

  // helper to get project title
  const getProjectTitle = (projectId) => {
    const project = projects.find((p) => p.projectId === projectId);
    return project ? project.prTitle : projectId; // fallback if not found
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">View Trips</span>

          {trips.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Trip ID</th>
                      <th>Employee ID</th>
                      <th>Trip Name</th>
                      <th>Project</th>
                      <th>Purpose of Travel</th>
                      <th>Department</th>
                      <th>Manager's Name</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Serial No</th>
                      <th>Approval Status</th>
                      <th>Created At</th>
                      <th>Created By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trips.map((trip, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{trip.tripId}</td>
                        <td>{trip.employeeId}</td>
                        <td>{trip.tripName}</td>
                        <td>{getProjectTitle(trip.project)}</td>{" "}
                        {/* show title */}
                        {/* <td>{trip.project}</td> */}
                        <td>{trip.purposeofTravel}</td>
                        <td>{trip.department}</td>
                        <td>{trip.managersName}</td>
                        <td>
                          {new Date(trip.tripStartDate).toLocaleDateString()}
                        </td>
                        <td>
                          {new Date(trip.tripEndDate).toLocaleDateString()}
                        </td>
                        <td>{trip.sno}</td>
                        <td>{trip.approvalStatus}</td>
                        <td>
                          {moment(trip.createdAt).format("L")} at{" "}
                          {moment(trip.createdAt).format("LTS")}
                        </td>
                        <td>{trip.createdBy}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No trips found.</p>
          )}
        </Container>
      </div>
    </>
  );
};

export default ViewTrip;
